<div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }">
	<div nz-col class="gutter-row" nzSpan="8">
		<nz-card>
				<div class="d-flex flex-wrap flex-column align-items-center">
					<div class="kit__utils__avatar kit__utils__avatar--size64 mb-3">
						<nz-avatar nzIcon="user" [nzShape]="'square'" [nzSize]="'large'" class="avatar avatar-100 text-center"></nz-avatar>
					</div>
					<div class="text-center">
						<div class="text-dark font-weight-bold font-size-18">{{ user?.name | titlecase }} {{ user?.username | titlecase }}</div>
						<div class="text-uppercase font-size-12 mb-3">{{ user?.roles[0] | translate | titlecase }}</div>
					</div>
				</div>
		</nz-card>
	</div>
	<div nz-col class="gutter-row" nzSpan="16">
		<nz-card>
			<p>GAMMA {{ username }}</p>
		</nz-card>
	</div>
</div>
